import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/helpers';

interface AuthError {
  type: string;
  message: string;
}

export function AccessDeniedPage() {
  const intl = useIntl();
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    // Get error from sessionStorage
    const authError = sessionStorage.getItem('auth_error');
    if (authError) {
      try {
        const error: AuthError = JSON.parse(authError);
        setErrorMessage(error.message);
        // Error will be cleared when user clicks back
      } catch (e) {
        console.error('Error parsing auth error:', e);
      }
    }
  }, []);
  
  const handleBackToLogin = () => {
    // Clear error state
    sessionStorage.removeItem('auth_error');
    
    // Clear all storage
    sessionStorage.clear();
    localStorage.clear();
    
    // Force logout from Auth0 and redirect to login
    const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || 'konfidency.us.auth0.com';
    const clientId = 'gNlboCgjC7I8rg4ofHmazO4C3jCTmE0M';
    const returnTo = encodeURIComponent(window.location.origin);
    
    // Logout from Auth0 and come back to login
    window.location.href = `https://${auth0Domain}/v2/logout?client_id=${clientId}&returnTo=${returnTo}`;
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-column-fluid">
        <div className="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20">

          <div className="pt-lg-10 mb-10">
            <h1 className="fw-bolder fs-2qx text-gray-800 mb-10">
              {intl.formatMessage({
                id: 'error.access-denied.title',
                defaultMessage: 'Acesso Negado',
              })}
            </h1>

            <div className="fw-bold fs-3 text-muted mb-15 max-w-600px mx-auto">
              {errorMessage || intl.formatMessage({
                id: 'error.access-denied.default-message',
                defaultMessage: 'Você não tem permissão para acessar este recurso.',
              })}
            </div>

            <div className="text-center">
              <button
                onClick={handleBackToLogin}
                className="btn btn-lg btn-primary"
              >
                {intl.formatMessage({
                  id: 'error.access-denied.back-button',
                  defaultMessage: 'Voltar ao Login',
                })}
              </button>
            </div>
          </div>

          <div className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px"
            style={{
              backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/sketchy-1/17.png')}')`
            }}
          />
        </div>
      </div>
    </div>
  );
}
